import script from "./claim-invite-person.vue?vue&type=script&lang=ts&setup=true"
export * from "./claim-invite-person.vue?vue&type=script&lang=ts&setup=true"

import "./claim-invite-person.vue?vue&type=style&index=0&id=6664e63e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6664e63e"]])

export default __exports__